import Velocity from 'velocity-animate';

export default class Position {
  // Since our Frame doesn't have a stylesheet we will prepare
  // the media here with some basic styles.
  static prepare({ type, node }) {
    // Because the Velocity hook doesn't support multi-prop
    // setting. For reasons, again.
    Velocity.hook(node, 'position', 'absolute');
    Velocity.hook(node, 'opacity', '0');
    Velocity.hook(node, 'left', '0');
    Velocity.hook(node, 'top', '0');

    // For our HTML5 advert we want to have it fullscreen all the time
    if (type === 'html5') {
      Velocity.hook(node, 'width', '100%');
      Velocity.hook(node, 'height', '100%');
    }
  }

  // Based on the media given and it's original width/height,
  // we'll scale the image to fit (centered) in the viewport
  static fullscreen(media) {
    // HTML5 is always fullscreen, all the time. Edge-cases are handled
    // inside of the advert itself.
    if (media.type === 'html5') {
      return;
    }

    // In our case the canvas matches the viewport dimensions
    const canvas = {
      height: window.innerHeight,
      width: window.innerWidth,
    };

    // Determine the resized scale
    const scaleWidth = canvas.width / media.naturalWidth;
    const scaleHeight = canvas.height / media.naturalHeight;
    let scale = scaleWidth > scaleHeight ? scaleWidth : scaleHeight;
    if (scale * media.naturalWidth < 320) {
      // minimum of 320
      scale = 320 / media.naturalWidth;
    }

    // Determine the new width/height and offset.
    const height = parseInt(scale * media.naturalHeight, 10);
    const width = parseInt(scale * media.naturalWidth, 10);
    const left = parseInt(0 - (width - canvas.width) / 2, 10);
    const top = parseInt(0 - (height - canvas.height) / 2, 10);

    // Update inline CSS
    Velocity.hook(media.node, 'width', width + 'px');
    Velocity.hook(media.node, 'height', height + 'px');
    Velocity.hook(media.node, 'translateY', top + 'px');
    Velocity.hook(media.node, 'translateX', left + 'px');
  }
}
